export default __webpack_public_path__ + "static/media/reduce.3d781a73.svg";